import { defineMessages } from 'react-intl';

export default defineMessages({
  priceBreakdownGifsCardsTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.priceBreakdownGifsCardsTitle.title',
    description: 'Message for the price breakdown gift cards discounts title',
    defaultMessage: `Gift Cards {count, plural,
      =0 {}
      other {({count})}
    }`,
  },
  priceBreakdownTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.title',
    description: 'Message for the price breakdown title',
    defaultMessage: 'Price',
  },
  priceBreakdownItems: {
    id: 'OrderTotalsSummary.priceBreakdown.items',
    description: 'Message for the price breakdown title',
    defaultMessage: `{count, plural,
      one {1 item}
      other {{count} items}
    }`,
  },
  priceBreakdownTitleAndItems: {
    id: 'OrderTotalsSummary.priceBreakdown.priceAndItems',
    description: 'Message for the price breakdown title',
    defaultMessage: `Subtotal ({count, plural,
      one {1 item}
      other {{count} items}
    })`,
  },
  priceBreakdownShipping: {
    id: 'OrderTotalsSummary.priceBreakdown.shipping',
    description: 'Message for the price breakdown shipping',
    defaultMessage: 'Shipping',
  },
  priceBreakdownFreeInHomeShipping: {
    id: 'OrderTotalsSummary.priceBreakdown.freeInHomeShipping',
    description: 'Message for the in home price breakdown shipping',
    defaultMessage: 'Shipping (In-Home Setup)',
  },
  priceBreakdownDiscountsAppliedTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.discountsApplied.title',
    description: 'Message for the price breakdown products discounts title',
    defaultMessage: 'Discounts Applied',
  },
  priceBreakdownProductDiscountsTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.productDiscounts.title',
    description: 'Message for the price breakdown products discounts title',
    defaultMessage: 'Product Discounts',
  },
  beddingPromoTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.beddingPromo.title',
    description: 'Message for the price breakdown products discounts title',
    defaultMessage: `Gift Credit {remaining,plural,
      =0 {}
      other {({remaining} Remaining)}
    }`,
  },
  priceBreakdownPromoCodesTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.priceBreakdownPromoCodes.title',
    description: 'Message for the price breakdown promo codes title',
    defaultMessage: 'Promo Code(s)',
  },
  priceBreakdownTaxesTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.taxes.title',
    description: 'Message for the price breakdown products taxes title',
    defaultMessage: 'Taxes',
  },
  priceBreakdownRecyclingFeeTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.recyclingFee.title',
    description: 'Message for the price breakdown products recycling fee title',
    defaultMessage: 'Recycling fee',
  },
  priceBreakdownDeliveryFeeTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.deliveryFee.title',
    description: 'Message for the price breakdown products delivery fee title',
    defaultMessage: 'Delivery fee',
  },
  priceBreakdownMattresRemovalTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.mattressRemoval.title',
    description:
      'Message for the price breakdown products mattress removal title',
    defaultMessage: 'Mattress Removal',
  },
  priceBreakdownEstimatedTaxesTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.estimated.taxes.title',
    description:
      'Message for the price breakdown products taxes title (Estimated)',
    defaultMessage: 'Estimated Taxes',
  },
  priceBreakdownCalculateOnCheckoutTaxesTitle: {
    id: 'OrderTotalsSummary.priceBreakdown.calculated.checkout.taxes.title',
    description:
      'Message for the price breakdown products taxes title (Estimated)',
    defaultMessage: 'Tax calculated in checkout',
  },
  pricingPromoCodeTitle: {
    id: 'OrderTotalsSummary.price.promoCodes.title',
    description: 'Message for the price promo codes title',
    defaultMessage: 'Promo Code',
  },
  pricingPromoCodeAdd: {
    id: 'OrderTotalsSummary.price.promoCodes.add',
    description: 'Message for the price promo codes add option',
    defaultMessage: 'Add',
  },
  pricingSubtotalTitle: {
    id: 'OrderTotalsSummary.price.subtotal.title',
    description: 'Message for the price subtotal title',
    defaultMessage: 'Subtotal',
  },
  pricingTotalTitle: {
    id: 'OrderTotalsSummary.price.total.title',
    description: 'Message for the price total title',
    defaultMessage: 'Total',
  },
  pricingSubtotalFinanceLegendDesktop: {
    id: 'OrderTotalsSummary.pricingSubtotalFinanceLegendDesktop',
    defaultMessage: 'As low as',
  },
  pricingSubtotalFinanceLegendMobile: {
    id: 'OrderTotalsSummary.pricingSubtotalFinanceLegendMobile',
    defaultMessage: 'As low as',
  },
  pricingSubtotalFinanceLegendPostValue: {
    id: 'OrderTotalsSummary.pricingSubtotalFinanceLegendPostValue',
    defaultMessage: 'with financing',
  },
  pricingSubtotalFinanceAmountPeriod: {
    id: 'OrderTotalsSummary.price.subtotal.financing.amountWithPeriod',
    description: 'Message for the price subtotal financing amount/period',
    defaultMessage: '{money}{period}',
  },
  pricingSubtotalFinancePeriod: {
    id: 'OrderTotalsSummary.price.subtotal.financing.period',
    description: 'Message for the price subtotal financing period',
    defaultMessage: '/mo',
  },
  priceBreakdownWarranties: {
    id: 'OrderTotalsSummary.price.warranties',
    defaultMessage: 'Warranties',
  },
  affirmWithLogoLegend: {
    id: 'OrderTotalsSummary.affirmWithLogo.legend',
    description: 'Affirm Icon with text',
    defaultMessage: 'with',
  },
  affirmLogoAlt: {
    id: 'OrderTotalsSummary.affirmLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Affirm',
  },
  affirmLegendWithPriceFragmentOne: {
    id: 'OrderTotalsSummary.affirmLegendWithPriceFragmentOne',
    defaultMessage: 'As low as {price} {apr}',
  },
  affirmLegendWithPriceFragmentTwo: {
    id: 'OrderTotalsSummary.affirmLegendWithPriceFragmentTwo',
    defaultMessage: 'with {affirmLogo}',
  },
  affirmAPRText: {
    id: 'OrderTotalsSummary.affirmAPRText',
    defaultMessage: 'at 0% APR',
  },
});
